var _path, _path2, _path3, _path4, _path5;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgShapeThree(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M34.3374 35.9964H16.576C15.5476 35.9964 14.7139 35.1521 14.7139 34.1107V16.124C14.7139 15.0826 15.5476 14.2383 16.576 14.2383H34.3374C35.3658 14.2383 36.1995 15.0826 36.1995 16.124V34.1107C36.1995 35.1521 35.3658 35.9964 34.3374 35.9964Z",
    fill: "#FBCDD7"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M22.5915 23.8406H7.24916C6.3608 23.8406 5.64062 23.1205 5.64062 22.2321V6.88978C5.64062 6.00143 6.3608 5.28125 7.24916 5.28125H22.5915C23.4798 5.28125 24.2 6.00143 24.2 6.88978V22.2321C24.2 23.1205 23.4799 23.8406 22.5915 23.8406Z",
    fill: "#DC7296"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.1,
    d: "M16.2298 14.2402C15.33 14.2402 14.6006 14.9697 14.6006 15.8694V23.8399H22.5711C23.4708 23.8399 24.2003 23.1105 24.2003 22.2107V14.2402H16.2298Z",
    fill: "#7C63A4"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M12.0612 35.9995H4.94615C4.53418 35.9995 4.2002 35.6656 4.2002 35.2536V28.1385C4.2002 27.7266 4.53418 27.3926 4.94615 27.3926H12.0612C12.4732 27.3926 12.8072 27.7266 12.8072 28.1385V35.2536C12.8072 35.6656 12.4732 35.9995 12.0612 35.9995Z",
    fill: "#FEEFF2"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M30.8441 12.3559L27.8434 9.35518C27.3048 8.81659 27.3048 7.94334 27.8434 7.40469L30.8441 4.40394C31.3827 3.86535 32.256 3.86535 32.7946 4.40394L35.7954 7.40469C36.334 7.94327 36.334 8.81653 35.7954 9.35518L32.7946 12.3559C32.256 12.8945 31.3828 12.8945 30.8441 12.3559Z",
    fill: "#FEEFF2"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgShapeThree);
export default __webpack_public_path__ + "static/media/shape-three.4c50bb9b136d3f234884a5f9b7d24916.svg";
export { ForwardRef as ReactComponent };